import axios from '@/libs/http'

/**
 * 获取排行榜数据
 */
export const getRankingList = (pageNo, pageSize) => {
  return axios.request({
    url: '/s/c/ranking/list',
    params: {
      pageNo,
      pageSize
    },
    method: 'get'
  })
}
/**
 * 获取历史排名
 */
export const getHistoryRankings = (pageNo, pageSize) =>{
  return axios.request({
    url: '/s/c/ranking/history',
    params: {
      pageNo,
      pageSize
    },
    method: 'get'
  })
}

/**
 * 获取排行榜数据47
 */
export const getRankingList47 = (rankingBy,pageNo, pageSize) => {
  return axios.request({
    url: '/s/c/ranking/list47',
    params: {
      rankingBy,
      pageNo,
      pageSize
    },
    method: 'get'
  })
}
